import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 16v-6a2 2 0 1 1 4 0v6","key":"svg-0"}],["path",{"d":"M8 13h4","key":"svg-1"}],["path",{"d":"M16 8v8","key":"svg-2"}]]

const IconAi = createReactComponent('outline', 'ai', 'Ai', __iconNode);

export default IconAi;